import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceTeacher } from '../../hooks/useAuthorizedRequestForTeacher';
import { useNavigate } from 'react-router-dom';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ImageModal, Loader } from '../../components/ModalsCommonFunctions';
import ViewImageAndText from '../../components/ViewImageAndText';

const StudentRandomExam = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosCommon = generateAxiosInstanceCommon()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const [syllabusList, setSyllabusList] = useState([]);
    const [subjectList, setSubjectList] = useState([])
    const [classList, setClassList] = useState([])
    const [syType, setSyType] = useState()

    const initialExamPatterState = {
        exam_name: '',
        description: '',
        syllabus_structure_id: '',
        syllabus_structure_type: '',
        class_id: '',
        subject_id: '',
        lesson_wise_question: [],
        section_id: sectionMasterId
    }

    const [examCreateData, setExamCreateData] = useState(initialExamPatterState)
    const [questions, setQuestion] = useState([]);
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    useEffect(() => {
        if (examCreateData.subject_id != "") {
            const apiUrl = `/lesson-wise-question-count?type=${syType}&syllabusStructureMasterId=${examCreateData.syllabus_structure_id}&subjectId=${examCreateData.subject_id}`;
            authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
                .then(response => {
                    setQuestion(response.data.data)
                })
                .catch(error => {
                    setQuestion([])
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }, [examCreateData.subject_id]);

    const handleClassChange = (e) => {
        setExamCreateData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                syllabus_structure_id: '',
                syllabus_structure_type: '',
                subject_id: '',
            }
        })
        getSyllabusList(e.target.value)
        setQuestion([]);
    }



    useEffect(() => {
        const apiUrl = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setClassList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }, [])

    const getSyllabusList = (id) => {
        const apiUrlForSyllabus = `/get-all-syllabus-structure-grade-medium-board-wise?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&instituteGradeMasterId=${id}`;
        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        setSyType('')
        setSubjectList([])
        let id = e.target.value.split('').slice(0, -1).join('');
        let type = e.target.value.split('').pop()
        setSyType(e.target.value.split('').pop())

        setExamCreateData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: id,
                subject_id: '',
                syllabus_structure_type: type
            }
        })

        setQuestion([])

        if (type == "I") {
            const apiUrl2 = `get-institute-syllabus-structure-Wise-institute-subjects?id=${id}`;
            authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
                .then(response => {
                    setSubjectList(response.data.result)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }

        if (type == "A") {
            const apiUrl2 = `/syllabus-structure-wise-subjects?id=${id}`;
            authorizedAxios && authorizedAxios.get(apiUrl2)
                .then(response => {
                    setSubjectList(response.data.result)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }

        if (type == "B") {
            const apiUrl2 = `/get-section-syllabus-structure-Wise-section-subjects?id=${id}`;
            authorizedAxiosSection && authorizedAxiosSection.get(apiUrl2)
                .then(response => {
                    setSubjectList(response.data.result)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }

    const handleSubjectChange = (e) => {
        const { name, value } = e.target;
        setExamCreateData((prevData) => {
            return {
                ...prevData,
                [name]: value,
            }
        })

        const apiUrl = `/lesson-wise-question-count?type=${syType}&syllabusStructureMasterId=${examCreateData.syllabus_structure_id}&subjectId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setQuestion(response.data.data)
            })
            .catch(error => {
                setQuestion([])
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    // const handleInputResultPublishTimeChange = (time) => {
    //     const formattedTime = dayjs(time).format('h:mm A');
    //     setExamCreateData((prevData) => ({
    //         ...prevData,
    //         result_publish_time: formattedTime
    //     }));
    // };

    const initialErrorState = {
        lesson_wise_question: []
    }

    const [error, setError] = useState(initialErrorState)


    // const validateForm = () => {
    //     const mandatoryFields = Object.keys(examCreateData).filter(field =>
    //         !['institute_id', 'section_id', 'type', 'exam_total_time', 'password_type'].includes(field)
    //     );

    //     const allErrorsEmpty = Object.keys(error)
    //         .filter(key => key !== 'lesson_wise_question')
    //         .every(key => error[key] === '');

    //     let anyLessonWiseQuestionError = true;
    //     if (Array.isArray(error.lesson_wise_question) && error.lesson_wise_question.length > 0) {
    //         anyLessonWiseQuestionError = Array.isArray(error.lesson_wise_question) && error.lesson_wise_question.some(item => item.error == '');
    //     } else if (error.lesson_wise_question.length == 0) {
    //         anyLessonWiseQuestionError = true;
    //     }

    //     const allMandatoryFieldsFilled = mandatoryFields.every(field => {
    //         if (field === 'lesson_wise_question') {
    //             if (Array.isArray(examCreateData[field]) && examCreateData[field].length > 0) {
    //                 return examCreateData[field].every(item => typeof item.questions === 'string' && item.questions.trim() !== '');
    //             } else {
    //                 return true;
    //             }
    //         } else if (field === 'result_publish_date' || field === 'result_publish_time') {
    //             if (!examCreateData.result_show) {
    //                 return typeof examCreateData[field] === "string" ? examCreateData[field] !== '' : examCreateData[field]?.length !== 0;
    //             } else {
    //                 return true;
    //             }
    //         } else if (field === 'positive_marks_per_question' || field === 'negative_marks_per_question') {
    //             if (examCreateData.positive_marks_per_question.length !== 0 && examCreateData.positive_marks_per_question !== "" &&
    //                 examCreateData.negative_marks_per_question !== "" && examCreateData.negative_marks_per_question.length !== 0 &&
    //                 examCreateData.negative_marks_per_question > examCreateData.positive_marks_per_question) {
    //                 return false;
    //             } else {
    //                 return typeof examCreateData[field] === "string" ? examCreateData[field] !== '' : examCreateData[field]?.length !== 0;
    //             }
    //         } else if (field === "from_date" || field === "to_date") {
    //             if (examCreateData.from_date.length !== 0 && examCreateData.from_date !== "" &&
    //                 examCreateData.to_date !== "" && examCreateData.to_date.length !== 0 &&
    //                 examCreateData.from_date > examCreateData.to_date) {
    //                 return false;
    //             } else {
    //                 return typeof examCreateData[field] === "string" ? examCreateData[field] !== '' : examCreateData[field]?.length !== 0;
    //             }
    //         } else if (field === 'password') {
    //             if (examCreateData.password_type === "M") {
    //                 return examCreateData.password && examCreateData.password.trim() !== '';
    //             } else {
    //                 return true;
    //             }
    //         } else {
    //             return typeof examCreateData[field] === "string" ? examCreateData[field] !== '' : examCreateData[field]?.length !== 0;
    //         }
    //     });

    //     return allErrorsEmpty && allMandatoryFieldsFilled && anyLessonWiseQuestionError;
    // };

    const validateForm = () => {
        // Define the mandatory fields, excluding only 'section_id'
        const mandatoryFields = Object.keys(examCreateData).filter(field =>
            field !== 'section_id' // Exclude only 'section_id'
        );

        // Check if there are no errors in the error state (except for lesson_wise_question)
        const allErrorsEmpty = Object.keys(error)
            .filter(key => key !== 'lesson_wise_question')
            .every(key => error[key] === '');

        // Check for lesson_wise_question specific validation
        let anyLessonWiseQuestionError = true;
        if (Array.isArray(error.lesson_wise_question) && error.lesson_wise_question.length > 0) {
            anyLessonWiseQuestionError = error.lesson_wise_question.some(item => item.error === '');
        } else if (error.lesson_wise_question.length === 0) {
            anyLessonWiseQuestionError = true;
        }

        // Validate all mandatory fields present in examCreateData
        const allMandatoryFieldsFilled = mandatoryFields.every(field => {
            if (field === 'lesson_wise_question') {
                // Only validate if the field is present and has data
                if (Array.isArray(examCreateData[field]) && examCreateData[field].length > 0) {
                    return examCreateData[field].every(item => typeof item.questions === 'string' && item.questions.trim() !== '');
                } else {
                    return true;
                }
            }

            // Validate for other fields only if they are present in examCreateData
            if (examCreateData.hasOwnProperty(field)) {
                return typeof examCreateData[field] === 'string' ? examCreateData[field] !== '' : examCreateData[field]?.length !== 0;
            }

            return true; // return true for fields not present in examCreateData
        });

        // Return the validation result
        return allErrorsEmpty && allMandatoryFieldsFilled && anyLessonWiseQuestionError;
    };


    // useEffect(() => {
    //     if (examCreateData.result_show) {
    //         if (examCreateData.result_publish_date !== "") {
    //             setExamCreateData((prevData) => ({
    //                 ...prevData,
    //                 result_publish_date: '',
    //             }));
    //         }
    //         if (examCreateData.result_publish_time !== "") {
    //             setExamCreateData((prevData) => ({
    //                 ...prevData,
    //                 result_publish_time: '',
    //             }));
    //         }
    //     }
    // }, [examCreateData.result_show])

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(error)) {
                if (['lesson_wise_question', 'section_id', 'institute_id', 'type', 'exam_total_time', 'password_type'].includes(key)) {
                    continue; // Skip validation for these fields
                }

                if (key === 'result_publish_date' || key === 'result_publish_time') {
                    if (!examCreateData.result_show) {
                        // Validate result_publish_date and result_publish_time only if result_show is false
                        if (examCreateData[key] === '') {
                            setError((prevData) => ({
                                ...prevData,
                                [key]: 'This field is required.',
                            }));
                        } else if (examCreateData[key]?.length !== 0 && examCreateData[key] !== '' && error[key]?.length !== 0 && error[key] !== '') {
                            setError((prevData) => ({
                                ...prevData,
                                [key]: '',
                            }));
                        }
                    } else {
                        // Clear errors for result_publish_date and result_publish_time if result_show is true
                        if (error[key] !== '') {
                            setError((prevData) => ({
                                ...prevData,
                                [key]: '',
                            }));
                        }
                    }
                } else if ((key === "positive_marks_per_question" || key === "negative_marks_per_question") && examCreateData[key].length !== 0 && examCreateData[key] !== "" && examCreateData.negative_marks_per_question !== "" && examCreateData.negative_marks_per_question.length !== 0 && examCreateData.negative_marks_per_question > examCreateData.positive_marks_per_question) {
                    setError((prevData) => ({
                        ...prevData,
                        ["positive_marks_per_question"]: "",
                        ["negative_marks_per_question"]: "Negative marks should not be greater than positive marks",
                    }))
                } else if ((key === "from_date" || key === "to_date") && examCreateData[key].length !== 0 && examCreateData[key] !== "" && examCreateData.to_date !== "" && examCreateData.to_date.length !== 0 && new Date(examCreateData.to_date) < new Date(examCreateData.from_date)) {
                    setError((prevData) => ({
                        ...prevData,
                        ["from_date"]: "",
                        ["to_date"]: "To date should not be less than from date",
                    }))
                } else {
                    if (examCreateData[key] === '') {
                        setError((prevData) => ({
                            ...prevData,
                            [key]: 'This field is required.',
                        }));
                    } else if (examCreateData[key]?.length !== 0 && examCreateData[key] !== '' && error[key]?.length !== 0 && error[key] !== '') {
                        setError((prevData) => ({
                            ...prevData,
                            [key]: '',
                        }));
                    }
                }
            }
        }
    }, [examCreateData]);

    const generateQuestions = (lessonWiseQuestions) => {
        // Initialize an array to store the generated questions for each lesson
        const generatedQuestionsArray = [];

        // Iterate through each lesson-wise question object in lessonWiseQuestions
        lessonWiseQuestions.forEach(lessonWiseQuestion => {
            // Find the lesson in lessonData based on the lesson_id of the current lessonWiseQuestion object
            const lessonInfo = questions.find(lesson => lesson.id === lessonWiseQuestion.lesson_id);

            if (lessonInfo) {
                // Initialize result array for the current lesson
                let result = [];

                // Iterate through each range in lessonWiseQuestion.questions
                const ranges = lessonWiseQuestion.questions.trim().split(',');
                for (let i = 0; i < ranges.length; i++) {
                    const r = ranges[i];
                    if (r.includes('-')) {
                        const [start, end] = r.split('-').map(Number);
                        for (let j = start; j <= end; j++) {
                            result.push(lessonInfo.ids[j - 1]);
                        }
                    } else {
                        result.push(lessonInfo.ids[Number(r.trim()) - 1]);
                    }
                }

                // Push the generated questions for the current lesson to the generatedQuestionsArray
                generatedQuestionsArray.push({ subject_id: lessonWiseQuestion.subject_id, lesson_id: lessonInfo.id, questions: result });
            }
        });

        return generatedQuestionsArray;
    };

    // const uploadExam = () => {
    //     if (validateForm()) {
    //         setLoading(true);
    //         if ('lesson_wise_question' in examCreateData && (!Array.isArray(examCreateData.lesson_wise_question) || examCreateData.lesson_wise_question.length === 0)) {
    //             Swal.fire({
    //                 text: "Please Select Atleast One Question."
    //             });
    //             return; // Return if lesson_wise_question is empty
    //         }
    //         const mergedData = {
    //             ...examCreateData,
    //             lesson_wise_question: generateQuestions(examCreateData.lesson_wise_question)
    //         };

    //         // Remove result_publish_date and result_publish_time keys from mergedData
    //         delete mergedData.result_publish_date;
    //         delete mergedData.result_publish_time;

    //         // Check if result_show is false
    //         if (!examCreateData.result_show) {
    //             // Parse the time and convert it to 24-hour format
    //             const parsedTime = dayjs(examCreateData.result_publish_time, 'h:mm A');
    //             const time24HourFormat = parsedTime.format('HH:mm');

    //             // Combine date and time into one string
    //             const combinedDateTime = `${examCreateData.result_publish_date} ${time24HourFormat}`;

    //             // Add result_publish_date_time key to mergedData
    //             mergedData.result_publish_date_time = combinedDateTime;
    //         }

    //         const apiUrlForSyllabus = `/teacherexam`;

    //         authorizedAxiosSection && authorizedAxiosSection.post(apiUrlForSyllabus, mergedData)
    //             .then(response => {
    //                 Swal.fire(
    //                     { text: response.data.message }
    //                 );

    //                 setExamCreateData(initialExamPatterState);
    //                 setSyllabusList([]);
    //                 setSubjectList([]);
    //                 setSyType();
    //                 setQuestion([]);
    //                 setError(initialErrorState);
    //             })
    //             .catch(error => {
    //                 const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //                 Swal.fire({
    //                     text: errorMsg
    //                 })
    //             })
    //             .finally(() => {
    //                 setLoading(false); // End loading
    //             });
    //     } else {
    //         for (const [key, value] of Object.entries(examCreateData)) {
    //             if (['lesson_wise_question', 'section_id', 'institute_id', 'type', 'exam_total_time', 'password_type'].includes(key)) {
    //                 continue; // Skip validation for these fields
    //             }

    //             if (key === 'result_publish_date' || key === 'result_publish_time') {
    //                 if (!examCreateData.result_show) {
    //                     // Validate result_publish_date and result_publish_time only if result_show is false
    //                     if (value === '' || value.length === 0) {
    //                         setError((prevData) => ({
    //                             ...prevData,
    //                             [key]: 'This field is required.',
    //                         }));
    //                     } else if (examCreateData[key]?.length !== 0 && examCreateData[key] !== '' && error[key]?.length !== 0 && error[key] !== '') {
    //                         setError((prevData) => ({
    //                             ...prevData,
    //                             [key]: '',
    //                         }));
    //                     }
    //                 } else {
    //                     // Clear errors for result_publish_date and result_publish_time if result_show is true
    //                     if (error[key] !== '') {
    //                         setError((prevData) => ({
    //                             ...prevData,
    //                             [key]: '',
    //                         }));
    //                     }
    //                 }
    //             } else if ((key === "positive_marks_per_question" || key === "negative_marks_per_question") && examCreateData[key].length !== 0 && examCreateData[key] !== "" && examCreateData.negative_marks_per_question !== "" && examCreateData.negative_marks_per_question.length !== 0 && examCreateData.negative_marks_per_question > examCreateData.positive_marks_per_question) {
    //                 setError((prevData) => ({
    //                     ...prevData,
    //                     ["positive_marks_per_question"]: "",
    //                     ["negative_marks_per_question"]: "Negative marks should not be greater than positive marks",
    //                 }))
    //             } else if ((key === "from_date" || key === "to_date") && examCreateData[key].length !== 0 && examCreateData[key] !== "" && examCreateData.to_date !== "" && examCreateData.to_date.length !== 0 && new Date(examCreateData.to_date) < new Date(examCreateData.from_date)) {
    //                 setError((prevData) => ({
    //                     ...prevData,
    //                     ["from_date"]: "",
    //                     ["to_date"]: "To date should not be less than from date",
    //                 }))
    //             } else if (key === 'password') {
    //                 // Only validate password if password_type is "M"
    //                 if (examCreateData.password_type === 'M') {
    //                     if (examCreateData[key] === '') {
    //                         setError((prevData) => ({
    //                             ...prevData,
    //                             password: 'Password is required.',
    //                         }));
    //                     } else if (examCreateData[key]?.length !== 0 && examCreateData[key] !== '' && error[key]?.length !== 0 && error[key] !== '') {
    //                         setError((prevData) => ({
    //                             ...prevData,
    //                             password: '',
    //                         }));
    //                     }
    //                 } else {
    //                     // Clear any errors for password if password_type is "R"
    //                     setError((prevData) => ({
    //                         ...prevData,
    //                         password: '',
    //                     }));
    //                 }
    //             } else {
    //                 if (examCreateData[key] === '') {
    //                     setError((prevData) => ({
    //                         ...prevData,
    //                         [key]: 'This field is required.',
    //                     }));
    //                 } else if (examCreateData[key]?.length !== 0 && examCreateData[key] !== '' && error[key]?.length !== 0 && error[key] !== '') {
    //                     setError((prevData) => ({
    //                         ...prevData,
    //                         [key]: '',
    //                     }));
    //                 }
    //             }
    //         }
    //     }
    // }

    const uploadExam = () => {
        if (validateForm()) {
            setLoading(true);

            if ('lesson_wise_question' in examCreateData && (!Array.isArray(examCreateData.lesson_wise_question) || examCreateData.lesson_wise_question.length === 0)) {
                setLoading(false);
                Swal.fire({
                    text: "Please Select Atleast One Question."
                });
                return; // Return if lesson_wise_question is empty
            }

            // const mergedData = {
            //     ...examCreateData,
            //     exam_type: "R",
            //     isMulti: "N",
            //     questions: generateQuestions(examCreateData.lesson_wise_question)
            // };

            const { lesson_wise_question, ...examDataWithoutLessonWiseQuestion } = examCreateData;

            const mergedData = {
                ...examDataWithoutLessonWiseQuestion, // Spread the rest of the fields except `lesson_wise_question`
                exam_type: "R",
                isMulti: "N",
                questions: generateQuestions(examCreateData.lesson_wise_question) // Use lesson_wise_question for questions
            };

            const apiUrl = `/exams-v2`;

            authorizedAxiosSection && authorizedAxiosSection.post(apiUrl, mergedData)
                .then(response => {
                    Swal.fire(
                        { text: response.data.message }
                    );

                    setExamCreateData(initialExamPatterState);
                    setSyllabusList([]);
                    setSubjectList([]);
                    setSyType();
                    setQuestion([]);
                    setError(initialErrorState);
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({
                        text: errorMsg
                    })
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(examCreateData)) {
                if (['lesson_wise_question'].includes(key)) {
                    continue; // Skip validation for these fields
                }

                if (examCreateData[key] === '') {
                    setError((prevData) => ({
                        ...prevData,
                        [key]: 'This field is required.',
                    }));
                } else if (examCreateData[key]?.length !== 0 && examCreateData[key] !== '' && error[key]?.length !== 0 && error[key] !== '') {
                    setError((prevData) => ({
                        ...prevData,
                        [key]: '',
                    }));
                }
            }
        }
    };


    const isInputStringValid = (inputString, questionCount) => {
        // Trim whitespace from the start and end of the input string
        inputString = inputString.trim();

        // Check if input string is empty
        if (inputString === '') {
            return false;
        }

        const words = inputString.split(/\s*,\s*/); // Split input string by commas and trim spaces
        for (let i = 0; i < words.length; i++) {
            const word = words[i];
            if (!/^\d+(-\d+)?$/.test(word)) { // Check if word is in the format "number" or "number-number"
                return 'Invalid page range format, use e.g. 1-5, 8, 11-13';
            }
        }

        const ranges = inputString.split(',');

        for (let r of ranges) {
            // Trim whitespace from the start and end of the range
            r = r.trim();

            // Check if the range contains alphabets or special characters
            if (!/^\d+(-\d+)?(, \d+(-\d+)?)*$/.test(r)) {
                return 'Invalid page range format, use e.g. 1-5, 8, 11-13';
            }

            if (r.includes('-')) {
                let [start, end] = r.split('-').map(Number);
                // start = start.trim();
                // end = end.trim();

                for (let i = start; i <= end; i++) {
                    if (i > questionCount) {
                        return `Out of bounds question reference, limit is ${questionCount}`;
                    }
                }
            } else {
                if (r > questionCount) {
                    return `Out of bounds question reference, limit is ${questionCount}`;
                }
            }
        }

        return false;
    }

    // const updateErrorState = (lessonId, inputString, questionCount) => {
    //     // Check if input string is valid
    //     const errorMessage = isInputStringValid(inputString, questionCount);

    //     // Update error state
    //     setError(prevState => {
    //         // Find the index of the lesson in lesson_wise_question array
    //         const existingLessonIndex = prevState?.lesson_wise_question?.findIndex(lesson => lesson.lesson_id === lessonId);
    //         if (existingLessonIndex !== -1) {
    //             // If lesson exists and error message is not false, update its error message
    //             if (errorMessage !== false) {
    //                 let updatedLessonWiseQuestion = [...prevState.lesson_wise_question];
    //                 updatedLessonWiseQuestion[existingLessonIndex] = {
    //                     ...updatedLessonWiseQuestion[existingLessonIndex],
    //                     error: errorMessage
    //                 };
    //                 return {
    //                     ...prevState,
    //                     lesson_wise_question: updatedLessonWiseQuestion
    //                 };
    //             } else {
    //                 // If error message is false, remove the object with matching lessonId
    //                 const updatedLessonWiseQuestion = prevState.lesson_wise_question.filter(lesson => lesson.lesson_id !== lessonId);
    //                 return {
    //                     ...prevState,
    //                     lesson_wise_question: updatedLessonWiseQuestion
    //                 };
    //             }
    //         } else if (errorMessage !== false) {
    //             // If lesson doesn't exist and error message is not false, add a new object with error message
    //             return {
    //                 ...prevState,
    //                 lesson_wise_question: [
    //                     ...prevState.lesson_wise_question,
    //                     { lesson_id: lessonId, error: errorMessage }
    //                 ]
    //             };
    //         } else {
    //             // If lesson doesn't exist and error message is false, return the previous state without modification
    //             return prevState;
    //         }
    //     });
    // };

    const updateErrorState = (lessonId, subjectId, inputString, questionCount) => {
        // Check if input string is valid
        const errorMessage = isInputStringValid(inputString, questionCount);
    
        // Update error state
        setError(prevState => {
            // Find the index of the lesson in lesson_wise_question array with both lessonId and subjectId
            const existingLessonIndex = prevState?.lesson_wise_question?.findIndex(
                lesson => lesson.lesson_id === lessonId && lesson.subject_id === subjectId
            );
    
            if (existingLessonIndex !== -1) {
                // If lesson exists and error message is not false, update its error message
                if (errorMessage !== false) {
                    let updatedLessonWiseQuestion = [...prevState.lesson_wise_question];
                    updatedLessonWiseQuestion[existingLessonIndex] = {
                        ...updatedLessonWiseQuestion[existingLessonIndex],
                        error: errorMessage
                    };
                    return {
                        ...prevState,
                        lesson_wise_question: updatedLessonWiseQuestion
                    };
                } else {
                    // If error message is false, remove the object with matching lessonId and subjectId
                    const updatedLessonWiseQuestion = prevState.lesson_wise_question.filter(
                        lesson => !(lesson.lesson_id === lessonId && lesson.subject_id === subjectId)
                    );
                    return {
                        ...prevState,
                        lesson_wise_question: updatedLessonWiseQuestion
                    };
                }
            } else if (errorMessage !== false) {
                // If lesson doesn't exist and error message is not false, add a new object with error message
                return {
                    ...prevState,
                    lesson_wise_question: [
                        ...prevState.lesson_wise_question,
                        { lesson_id: lessonId, subject_id: subjectId, error: errorMessage }
                    ]
                };
            } else {
                // If lesson doesn't exist and error message is false, return the previous state without modification
                return prevState;
            }
        });
    };
    

    // const handleGridDataChange = (e, lessonId, questionCount) => {
    //     let { name, value } = e.target;
    //     // Check if value is empty, and if examCreateData contains the lessonId

    //     // Update error state
    //     updateErrorState(lessonId, value, questionCount);

    //     if (value.trim() === '' && examCreateData.lesson_wise_question.some(lesson => lesson.lesson_id === lessonId)) {
    //         // Remove the lesson object from examCreateData
    //         const updatedLessonWiseQuestion = examCreateData.lesson_wise_question.filter(lesson => lesson.lesson_id !== lessonId);
    //         setExamCreateData(prevState => ({
    //             ...prevState,
    //             lesson_wise_question: updatedLessonWiseQuestion
    //         }));
    //     } else {
    //         // Check if lesson exists in the lesson_wise_question array
    //         const existingLessonIndex = examCreateData.lesson_wise_question.findIndex(lesson => lesson.lesson_id === lessonId);
    //         // If lesson exists, update its field value
    //         if (existingLessonIndex !== -1) {
    //             const updatedLessonWiseQuestion = examCreateData.lesson_wise_question.map((lesson, index) => {
    //                 if (index === existingLessonIndex) {
    //                     return {
    //                         ...lesson,
    //                         lesson_id: lessonId,
    //                         [name]: value,
    //                     }; // Use 'name' instead of e.target.name
    //                 }
    //                 return lesson;
    //             });

    //             // Update the state with the modified lesson_wise_question array
    //             setExamCreateData(prevState => ({
    //                 ...prevState,
    //                 lesson_wise_question: updatedLessonWiseQuestion
    //             }));
    //         } else {
    //             // If lesson doesn't exist, create a new lesson object and insert it into the array
    //             const newLesson = {
    //                 lesson_id: lessonId,
    //                 [name]: value,
    //             };

    //             // Add the new lesson object to the lesson_wise_question array
    //             setExamCreateData(prevState => ({
    //                 ...prevState,
    //                 lesson_wise_question: [...prevState.lesson_wise_question, newLesson]
    //             }));
    //         }
    //     }
    // };

    const handleGridDataChange = (e, lessonId, subjectId, questionCount) => {
        let { name, value } = e.target;
    
        // Check if value is empty, and if examCreateData contains both lessonId and subjectId
        updateErrorState(lessonId, subjectId, value, questionCount);
    
        if (
            value.trim() === '' &&
            examCreateData.lesson_wise_question.some(
                lesson => lesson.lesson_id === lessonId && lesson.subject_id === subjectId
            )
        ) {
            // Remove the lesson object if both lessonId and subjectId match
            const updatedLessonWiseQuestion = examCreateData.lesson_wise_question.filter(
                lesson => !(lesson.lesson_id === lessonId && lesson.subject_id === subjectId)
            );
            setExamCreateData(prevState => ({
                ...prevState,
                lesson_wise_question: updatedLessonWiseQuestion
            }));
        } else {
            // Check if an entry with both lessonId and subjectId exists in the lesson_wise_question array
            const existingLessonIndex = examCreateData.lesson_wise_question.findIndex(
                lesson => lesson.lesson_id === lessonId && lesson.subject_id === subjectId
            );
    
            if (existingLessonIndex !== -1) {
                // If found, update the existing entry
                const updatedLessonWiseQuestion = examCreateData.lesson_wise_question.map((lesson, index) => {
                    if (index === existingLessonIndex) {
                        return {
                            ...lesson,
                            [name]: value,
                        };
                    }
                    return lesson;
                });
    
                setExamCreateData(prevState => ({
                    ...prevState,
                    lesson_wise_question: updatedLessonWiseQuestion
                }));
            } else {
                // If not found, create a new lesson object with lessonId and subjectId
                const newLesson = {
                    lesson_id: lessonId,
                    subject_id: subjectId,
                    [name]: value,
                };
    
                setExamCreateData(prevState => ({
                    ...prevState,
                    lesson_wise_question: [...prevState.lesson_wise_question, newLesson]
                }));
            }
        }
    };

    
    const handleInputChange = (e) => {
        const { name, value, type } = e.target;
        setExamCreateData((prevData) => {
            if (type === 'number' && (value !== "e" || value !== "E" || value !== "-" || value !== "+")) {
                return {
                    ...prevData,
                    [name]: value,
                };
            } else if (type !== 'number') {
                return {
                    ...prevData,
                    [name]: value,
                }
            }
        })
    }

    const calculateTotalCount = (id) => {
        const result = generateQuestions(examCreateData?.lesson_wise_question);
        const matchedObject = result.find(obj => obj.lesson_id === id);
        if (matchedObject) {
            const questionsLength = matchedObject.questions.length;
            return questionsLength;
        } else {
            // Handle case where no matching object is found
            return 0; // Or any other appropriate value
        }
    };

    const QuestionTable = ({ lessonWiseQuestion, questions, onViewImage }) => {
        // Function to filter questions based on examCreateData and lesson_wise_question
        const getFilteredQuestions = () => {
            return questions
                .filter(question =>
                    lessonWiseQuestion.some(
                        lwq => lwq.lesson_id === question.id &&
                            lwq.questions.some(id =>
                                question.qData.some(q => q.id === id)
                            )
                    )
                )
                .map(question => ({
                    ...question,
                    qData: question.qData.filter(q =>
                        lessonWiseQuestion
                            .find(lwq => lwq.lesson_id === question.id)
                            ?.questions.includes(q.id)
                    )
                }));
        };

        // const getFilteredQuestions = () => {
        //     return questions
        //         .flatMap(question => 
        //             question.qData.filter(qDataItem =>
        //                 lessonWiseQuestion.some(
        //                     lwq => lwq.lesson_id === question.id && lwq.questions.includes(qDataItem.id)
        //                 )
        //             )
        //         );
        // };

        // Get the filtered questions to display
        const filteredQuestions = getFilteredQuestions();
        let srNo = 1;
        return (
            <div className="d-grid gap-2 mt-2">
                <div className="tab-content rounded-bottom custom_table custom_table_width">
                    <div className="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col" className='sl_no'>Sr. No.</th>
                                    {/* <th scope='col'>Subject</th> */}
                                    <th scope='col'>Lesson</th>
                                    <th scope="col">Question</th>
                                    <th scope='col'>Solution</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    filteredQuestions.length > 0 ? (
                                        filteredQuestions.map((question, index) => (
                                            question.qData.map((qDataItem, qIndex) => (
                                                <tr key={`${index}-${qIndex}`}>
                                                    {/* <th scope="row" className='sl_no'>{index + 1}</th> */}
                                                    <th scope="row" className='sl_no'>{srNo++}</th>
                                                    {/* <td>{question.subjectName}</td> */}
                                                    <td>{question.lessonName}</td>
                                                    <ViewImageAndText inputString={qDataItem.question} onViewImage={onViewImage} />
                                                    <ViewImageAndText inputString={qDataItem.sol} onViewImage={onViewImage} />
                                                </tr>
                                            ))
                                        ))
                                    ) : (
                                        <tr>
                                            <th colSpan="100%" style={{ textAlign: 'center' }}>No Questions Available</th>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );

        // return (
        //     <div className="d-grid gap-2 mt-2">
        //         <div className="tab-content rounded-bottom custom_table custom_table_width">
        //             <div className="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
        //                 <table className="table">
        //                     <thead>
        //                         <tr>
        //                             <th scope="col" className='sl_no'>Sr. No.</th>
        //                             <th scope='col'>Subject</th>
        //                             <th scope='col'>Lesson</th>
        //                             <th scope="col">Question</th>
        //                             <th scope='col'>Solution</th>
        //                         </tr>
        //                     </thead>
        //                     <tbody>
        //                         {
        //                             filteredQuestions.length > 0 ? (
        //                                 filteredQuestions.map((qDataItem, index) => (
        //                                     <tr key={qDataItem.id}>
        //                                         <th scope="row" className='sl_no'>{index + 1}</th>
        //                                         <td>{qDataItem.subjectMasterId}</td>
        //                                         <td>{qDataItem.lessonMasterId}</td>
        //                                         <td>
        //                                             <ViewImageAndText inputString={qDataItem.question} onViewImage={onViewImage} />
        //                                         </td>
        //                                         <td>
        //                                             <ViewImageAndText inputString={qDataItem.sol} onViewImage={onViewImage} />
        //                                         </td>
        //                                     </tr>
        //                                 ))
        //                             ) : (
        //                                 <tr>
        //                                     <th colSpan="100%" style={{ textAlign: 'center' }}>No Questions Available</th>
        //                                 </tr>
        //                             )
        //                         }
        //                     </tbody>
        //                 </table>
        //             </div>
        //         </div>
        //     </div>
        // );
    };

    console.log({ examCreateData });
    console.log({ questions });



    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Random Exam</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-pen"></i> Random Exam</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Name </label>
                                                    <input type="text" className="form-control" id={`examName`} name='exam_name' onChange={handleInputChange} value={examCreateData.exam_name} />
                                                    {/* <ErrorMessage errors={error} field="exam_name" /> */}
                                                    {error.exam_name && <p style={{ color: 'red' }}>{error.exam_name}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="description" className="col-form-label"><span style={{ color: "red" }}>*</span>Description  </label>
                                                    <input type="text" className="form-control" id={`description`} name='description' onChange={handleInputChange} value={examCreateData.description} />
                                                    {/* <ErrorMessage errors={error} field="description" /> */}
                                                    {error.description && <p style={{ color: 'red' }}>{error.description}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="class_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='class_id' onChange={handleClassChange} value={examCreateData.class_id}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            classList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.class_id && <p style={{ color: 'red' }}>{error.class_id}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="syllabus_structure_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='syllabus_structure_id' onChange={handleSyllabusChange} value={examCreateData.syllabus_structure_id + syType}>
                                                        <option selected value={''} >Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option style={{ color: syllabus.type == "I" ? "blue" : syllabus.type == "B" ? "red" : '' }} value={syllabus.id + syllabus.type}>{syllabus?.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>

                                                    {error.syllabus_structure_id && <p style={{ color: 'red' }}>{error.syllabus_structure_id}</p>}
                                                </div>

                                                {syType == "B" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Subject :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChange} value={examCreateData?.subject_id}>
                                                            <option selected value={''} disabled>Select Subject</option>
                                                            {
                                                                subjectList?.map((syllabus) => {
                                                                    return <option value={syllabus?.instituteSubjectMasterDetails?.id}>{syllabus?.instituteSubjectMasterDetails?.subjectName}</option>
                                                                })
                                                            }
                                                        </select>

                                                        {error.subject_id && <p style={{ color: 'red' }}>{error.subject_id}</p>}
                                                    </div>
                                                </>}

                                                {syType == "I" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Subject :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChange} value={examCreateData?.subject_id}>
                                                            <option selected value={''} disabled>Select Subject</option>
                                                            {
                                                                subjectList?.map((syllabus) => {
                                                                    return <option value={syllabus?.instituteSubjectMasterDetails?.id}>{syllabus?.instituteSubjectMasterDetails?.subjectName}</option>
                                                                })
                                                            }
                                                        </select>

                                                        {error.subject_id && <p style={{ color: 'red' }}>{error.subject_id}</p>}
                                                    </div>
                                                </>}

                                                {syType == "A" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Subject :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChange} value={examCreateData?.subject_id}>
                                                            <option selected value={''} disabled>Select Subject</option>
                                                            {
                                                                subjectList?.map((syllabus) => {
                                                                    return <option value={syllabus?.subjectMasterDetails?.id}>{syllabus?.subjectMasterDetails?.subjectName}</option>
                                                                })
                                                            }
                                                        </select>

                                                        {error.subject_id && <p style={{ color: 'red' }}>{error.subject_id}</p>}
                                                    </div>
                                                </>}

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {examCreateData.syllabus_structure_id !== "" && examCreateData.subject_id !== "" &&
                                    <div className="container-lg">
                                        <div className="row">
                                            <div className="card border-info mx-auto mt-3">
                                                <div className="card-content collpase show">
                                                    <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                                        <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-eye"></i>Select Questions</b></h4>
                                                    </div>
                                                    <div className="card-body ">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="row">

                                                                    {examCreateData.syllabus_structure_id !== "" && examCreateData.subject_id !== "" &&
                                                                        <div className="d-grid gap-2 mt-2">
                                                                            <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                                                <table class="table">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                                            <th scope='col'>Lesson</th>
                                                                                            <th scope='col'>No Qut</th>
                                                                                            <th scope='col'>Enter Qut</th>
                                                                                            <th scope="col">Total Qut </th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {
                                                                                            questions?.length > 0 ?
                                                                                                (questions?.map((lesson, index) => {

                                                                                                    const correspondingLesson = examCreateData?.lesson_wise_question?.find(item => item.lesson_id === lesson.id);
                                                                                                    return (
                                                                                                        <tr key={index}>
                                                                                                            <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                                            <td>{lesson.lessonName}</td>
                                                                                                            <td>{lesson.questionCount}</td>
                                                                                                            <td>
                                                                                                                <input
                                                                                                                    type="text"
                                                                                                                    className="form-control"
                                                                                                                    id={`questions_${lesson.id}`}
                                                                                                                    name='questions'
                                                                                                                    placeholder='e.g. 1-5, 8, 11-13'
                                                                                                                    onChange={(e) => handleGridDataChange(e, lesson.id, examCreateData.subject_id, lesson.questionCount)}
                                                                                                                    value={(lesson.id === correspondingLesson?.lesson_id) ? correspondingLesson?.questions : ''}
                                                                                                                />

                                                                                                                {error.lesson_wise_question && (
                                                                                                                    error.lesson_wise_question.map(lessonError => {
                                                                                                                        if (lessonError.lesson_id === lesson.id) {
                                                                                                                            return (
                                                                                                                                <p key={lesson.id} style={{ color: 'red' }}>{lessonError.error}</p>
                                                                                                                            );
                                                                                                                        }
                                                                                                                        return null;
                                                                                                                    })
                                                                                                                )}
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                {calculateTotalCount(lesson.id)}
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    )
                                                                                                })
                                                                                                )
                                                                                                :
                                                                                                (<tr>
                                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Lessons Available</th>
                                                                                                </tr>)
                                                                                        }
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    }

                                                                    <div className='row'>
                                                                        <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                                            <div className="col-auto new_button">
                                                                                <button className="btn btn-primary" style={{ marginRight: '20px' }} type="button" onClick={uploadExam}>Save</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {examCreateData.lesson_wise_question.length > 0 && <QuestionTable lessonWiseQuestion={generateQuestions(examCreateData.lesson_wise_question)} questions={questions} onViewImage={onViewImage} />}

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}

                                {/* {questions.length !== 0 &&
                                    <div className="card-body ">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="row">

                                                    <div className="col-md-6">
                                                        <label for="positive_marks_per_question" className="col-form-label"><span style={{ color: "red" }}>*</span>Positive Marks Per Question :</label>
                                                        <input type="number" className="form-control custom-input" name="positive_marks_per_question" value={examCreateData.positive_marks_per_question} onChange={handleInputChange} />
                                                        {error.positive_marks_per_question && <p style={{ color: 'red' }}>{error.positive_marks_per_question}</p>}

                                                    </div>

                                                    <div className="col-md-6">
                                                        <label for="negative_marks_per_question" className="col-form-label"><span style={{ color: "red" }}>*</span>Negative Marks Per Question :</label>
                                                        <input type="number" className="form-control custom-input" name="negative_marks_per_question" value={examCreateData.negative_marks_per_question} onChange={handleInputChange} />
                                                        {error.negative_marks_per_question && <p style={{ color: 'red' }}>{error.negative_marks_per_question}</p>}
                                                    </div>

                                                    <div className="col-md-6">
                                                        <label for="time_per_question" className="col-form-label"><span style={{ color: "red" }}>*</span>Time Per Question (Minute) :</label>
                                                        <input type="number" className="form-control custom-input" name="time_per_question" value={examCreateData.time_per_question} onChange={handleInputChange} />
                                                        {error.time_per_question && <p style={{ color: 'red' }}>{error.time_per_question}</p>}

                                                    </div>

                                                    <div className="col-md-6">
                                                        <label for="from_date" className="col-form-label"><span style={{ color: "red" }}>*</span>From Date :</label>
                                                        <input type="date" className="form-control" name="from_date" value={examCreateData.from_date} onChange={handleInputChange} />
                                                        {error.from_date && <p style={{ color: 'red' }}>{error.from_date}</p>}

                                                    </div>

                                                    <div className="col-md-6">
                                                        <label for="to_date" className="col-form-label"><span style={{ color: "red" }}>*</span>To Date :</label>
                                                        <input type="date" className="form-control" name="to_date" value={examCreateData.to_date} onChange={handleInputChange} />
                                                        {error.to_date && <p style={{ color: 'red' }}>{error.to_date}</p>}

                                                    </div>

                                                    <div className="col-md-6 ">
                                                        <label for="exam_total_time" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Total Time (minutes) :</label>
                                                        <input type="text" className="form-control" id="exam_total_time" name='exam_total_time' value={examCreateData.exam_total_time} onChange={handleInputChange} />
                                                    </div>

                                                    <div className="col-md-6 ">
                                                        <label for="exam_total_time" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Total Marks :</label>
                                                        <input type="text" className="form-control" id="exam_total_marks" name='exam_total_marks' value={calculateTotalMarks()} disabled />
                                                    </div>

                                                    <div className="col-md-6 ">
                                                        <label for="passing_marks" className="col-form-label"><span style={{ color: "red" }}>*</span>Passing marks :</label>
                                                        <input type="text" className="form-control" id="passing_marks" name='passing_marks' value={examCreateData.passing_marks} onChange={handleInputChange} />
                                                        {error.passing_marks && <p style={{ color: 'red' }}>{error.passing_marks}</p>}
                                                    </div>
                                                    <div className="col-md-12 view_content_radio_btn">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Choose Password Type :</label>
                                                        <label>
                                                            <input type="radio" name="password_type" value="R" checked={examCreateData.password_type == "R"} onChange={handleInputChange} /> &nbsp;Random
                                                        </label>
                                                        <label>
                                                            <input type="radio" name="password_type" value="M" checked={examCreateData.password_type == "M"} onChange={handleInputChange} /> &nbsp;Manual
                                                        </label>
                                                    </div>

                                                    {examCreateData.password_type === "M" && <div className="col-md-6 ">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Password</label>
                                                        <input type="text" className="form-control" id="password" name='password' value={examCreateData.password} onChange={handleInputChange} />
                                                        {error.password && <p style={{ color: 'red' }}>{error.password}</p>}
                                                    </div>}
                                                </div>
                                                <div className='row mt-3'>

                                                    <div className="col-md-12 d-flex align-items-center">
                                                        <label htmlFor="result_show" className="col-form-label mb-0">Publish Result Instantly:</label>
                                                        <input type="checkbox" name="result_show" defaultValue={false} checked={examCreateData?.result_show}
                                                            style={{ marginLeft: '6px', width: '18px', height: '16px', accentColor: 'green', marginTop: '5px', }}
                                                            onChange={handleInputChange}
                                                        />
                                                        {error.result_show && <p style={{ color: 'red', marginLeft: '10px' }}>{error.result_show}</p>}
                                                    </div>

                                                    {!examCreateData.result_show && <>
                                                        <div className="col-md-6 ">
                                                            <div className='cstm_checkbox_field'>
                                                                <label for="result_publish_date" className="col-form-label"><span style={{ color: "red" }}>*</span>Result Publish Date :</label>
                                                                <input type="date" className="form-control" id="result_publish_date" name='result_publish_date' value={examCreateData.result_publish_date} onChange={handleInputChange} />
                                                                {error.result_publish_date && <p style={{ color: 'red' }}>{error.result_publish_date}</p>}
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className='cstm_time_picker'>
                                                                <label htmlFor="result_publish_time" className="col-form-label"><span style={{ color: "red" }}>*</span>Result Publish Time :</label>
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DemoContainer components={['TimePicker', 'TimePicker']}>
                                                                        <TimePicker
                                                                            value={dayjs(examCreateData.result_publish_time)}
                                                                            onChange={(newTime) => handleInputResultPublishTimeChange(newTime)}
                                                                        />
                                                                    </DemoContainer>
                                                                </LocalizationProvider>
                                                                {error.result_publish_time && <p style={{ color: 'red' }}>{error.result_publish_time}</p>}
                                                            </div>
                                                        </div></>}
                                                </div>
                                                <div className='row'>
                                                    <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                        <div className="col-auto new_button">
                                                            <button className="btn btn-primary" style={{ marginRight: '20px' }} type="button" onClick={uploadExam}>Save</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>} */}


                                {/* <div className="d-grid gap-2 mt-2">
                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                        <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                        <th scope='col'>Subject</th>
                                                        <th scope='col'>Lesson</th>
                                                        <th scope="col">Question</th>
                                                        <th scope='col'>Solution</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        questions?.length > 0 ?
                                                        questions?.map((question, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <th scope="row" className='sl_no'>{index + 1}</th>
                                                                        <td>{question.subjectName}</td>
                                                                        <td>{question.lessonName}</td>
                                                                        <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                                                        <ViewImageAndText inputString={question.sol} onViewImage={onViewImage} />
                                                                    </tr>
                                                                )
                                                            })
                                                            :
                                                            (<tr>
                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                            </tr>)
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div> */}




                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />


            {visibleImage && <ImageModal visibleImage={visibleImage} setVisibleImage={setVisibleImage} modalImageSrc={modalImageSrc} />}
        </>
    )
};

export default StudentRandomExam;